<div role="status" aria-live="polite">
  @if (connectivity.unavailable()) {
    <div class="server-unavailable-banner" data-testid="server-unavailable-banner">
      <mat-icon class="server-unavailable-banner__icon" aria-hidden="true">cloud_off</mat-icon>
      <span class="server-unavailable-banner__text">{{ 'common.serverUnavailable.banner' | translate }}</span>
    </div>
  }
</div>
